import { render, staticRenderFns } from "./PreviewPdfV2.vue?vue&type=template&id=2f85cbf4&"
import script from "./PreviewPdfV2.vue?vue&type=script&lang=js&"
export * from "./PreviewPdfV2.vue?vue&type=script&lang=js&"
import style0 from "./PreviewPdfV2.vue?vue&type=style&index=0&id=2f85cbf4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports